export default function useScrollSearch() {
  let startScrollY = 0
  let lastScrollY = 0
  let ticking = false
  let rafId: number
  let stationaryFrames = 0
  const STOP_FRAME_THRESHOLD = 3
  const hideElement = ref(false)

  const headerStore = useHeaderStore()
  const { headerHidden } = storeToRefs(headerStore)

  const searchStore = useSearchStore()
  const { suggestions } = storeToRefs(searchStore)

  function checkIfScrollStopped() {
    const currentY = window.scrollY

    if (currentY === lastScrollY) {
      stationaryFrames++
      if (stationaryFrames >= STOP_FRAME_THRESHOLD) {
        startScrollY = currentY
        ticking = false
        cancelAnimationFrame(rafId)
        return
      }
    }
    else {
      lastScrollY = currentY
      stationaryFrames = 0
    }

    rafId = requestAnimationFrame(checkIfScrollStopped)
  }

  function handleScroll() {
    if (headerHidden.value) {
      hideElement.value = false
      startScrollY = window.scrollY
      ticking = false
      cancelAnimationFrame(rafId)
      return
    }

    const currentY = window.scrollY

    if (currentY === 0) {
      hideElement.value = false
      startScrollY = currentY
      ticking = false
      cancelAnimationFrame(rafId)
      return
    }

    if ((currentY - startScrollY) > 20 && suggestions.value.length <= 0) {
      hideElement.value = true
    }
    else if ((startScrollY - currentY) > 20) {
      hideElement.value = false
    }

    if (!ticking) {
      ticking = true
      lastScrollY = currentY
      stationaryFrames = 0
      rafId = requestAnimationFrame(checkIfScrollStopped)
    }
  }

  function initScroll() {
    startScrollY = window.scrollY
    lastScrollY = startScrollY
    useEventListener('scroll', handleScroll)
  }

  return { hideElement, initScroll }
}
